import { useState } from "react";
import { useParams } from "react-router-dom";
import CustomerUsers from "@/components/customers/customer_users/CustomerUsers";

const CustomerUsersPage = () => {
  const { customerId } = useParams();
  const [customerName, setCustomerName] = useState<string>("");

  const handleCustomerLoaded = (name: string) => {
    setCustomerName(name);
  };

  return (
    <>
      <CustomerUsers
        CustomerId={Number(customerId)}
        onCustomerLoaded={handleCustomerLoaded}
        breadcrumbTitle="Customer | Users"
        breadcrumbSubtitle={
          customerName ? (
            <>
              Manage users for customer{" "}
              <strong style={{ fontWeight: "600" }}>{customerName}</strong>
            </>
          ) : (
            "Manage users for this customer"
          )
        }
      />
    </>
  );
};

export default CustomerUsersPage;
